
import Vue from 'vue';
import { MediaGalleryCarouselImage, MediaGalleryCarouselItem } from './MediaGalleryOverlay';
import GenericImage from '@owc-packages/GenericImage/src/GenericImage.vue';
import { createEventListener } from '@owc-utils/Mixins/EventListenerMixin';
import { THUMBNAILS_TOTAL_DISPLAY_AMOUNT, THUMBNAILS_THROTTLE_LIMIT } from './MediaGalleryOverlay.config';
import { isCarouselItemAVideo, transformCarouselToUnifiedFormat } from './MediaGalleryOverlayUtils';
export default Vue.extend({
  name: 'owc-media-gallery-carousel-thumbnails',
  mixins: [
    createEventListener('resize', 'updateVisibleItems', {
      throttleLimit: THUMBNAILS_THROTTLE_LIMIT,
    }),
  ],
  components: {
    GenericImage,
  },
  props: {
    thumbnails: {
      type: Array as () => MediaGalleryCarouselItem<MediaGalleryCarouselImage>[],
      required: true,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    itemCount(): number {
      return this.thumbnails.length;
    },
    isThumbnailsScrollable(): boolean {
      return this.itemCount > THUMBNAILS_TOTAL_DISPLAY_AMOUNT;
    },
    indexOfOverflingItem(): number {
      if (!this.isThumbnailsScrollable) {
        return -1;
      }
      const firstItemInRow = this.itemCount - THUMBNAILS_TOTAL_DISPLAY_AMOUNT;
      const lastItemInRow = THUMBNAILS_TOTAL_DISPLAY_AMOUNT - 1;
      return this.overflowingLeft ? firstItemInRow : lastItemInRow;
    },
  },
  watch: {
    value() {
      // update thumbnails when the value over v-model changed
      this.updateVisibleItems();
    },
  },
  data: () => ({
    overflowingLeft: false,
  }),
  mounted() {
    this.updateVisibleItems();
  },
  methods: {
    getThumbnailComponentId(item: MediaGalleryCarouselItem<MediaGalleryCarouselImage>): string {
      return this.isCarouselItemAVideo(item) ? `${item.id}-thumbnail` : item.id;
    },
    isCarouselItemAVideo,
    selectItem(index: number): void {
      this.updateVisibleItems();
      this.$emit('updateCurrentItem', index + 1);
    },
    updateVisibleItems(): void {
      const innerElement = this.$refs.inner as Element;
      const gridElement = this.$refs.grid as HTMLElement;
      let difference = 0;

      // move thumbnails to left then the currently active element
      // passed the center
      this.overflowingLeft = this.value + 1 > this.itemCount / 2;

      if (this.overflowingLeft && this.isThumbnailsScrollable) {
        difference = innerElement.clientWidth - gridElement.clientWidth;
      }

      gridElement.style.setProperty('--grid-left-offset', String(difference));
    },
    getThumbnailImageSource(item: MediaGalleryCarouselItem<MediaGalleryCarouselImage>): string {
      return transformCarouselToUnifiedFormat(item).src;
    },
  },
});
